export default {
    computed: {
        currentUserName() {
            return document.querySelector('html').getAttribute('data-user-name')
        },
        isAdmin() {
            return this.checkRole('isAdmin')
        },
        isManager() {
            return this.checkRole('isManager')
        },
        isEmployee() {
            return this.checkRole('isEmployee')
        },
        isAdminOrManager() {
            return this.isAdmin || this.isManager
        },
    },
    methods: {
        isFull(shift) {
            return shift.details.status === 'full'
        },
        isEnrolled(shift) {
            if (! this.isEmployee) return false

            const currentUser = document.querySelector('html')
                .getAttribute('data-user')

            return shift.enrolled.includes(currentUser)
        },
        checkRole(role) {
            return this.user[role] || false
        },
    },
}
